import { useRepositoryQuery, EnterpriseBuilderParametersType } from '@mews-commander/data-access';

export const useGetDependencyMappings = (propertyType: EnterpriseBuilderParametersType) =>
    useRepositoryQuery('enterpriseBuilder', 'getDependencyMappings', {
        exportType: propertyType,
    });
